'use client'
import type { FC } from 'react'
import styled from 'styled-components'
import { mq } from '@/styles'
import { SectionEvents } from './SectionEvents'
import type { TypeEventsSectionData } from '@/app/[lang]/page'

type Props = {
 data: TypeEventsSectionData
}

export const MainEvents:FC<Props> = ({ data }) => {

  return (
    <Main>
      <SectionEvents data={data} className='no-h2' />
    </Main>
  )
}

const Main = styled.main`
  grid-column: 1 / span 6;

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 12;
  }

  + .prefooter {
    display: none;
  }
`
